// extracted by css-extract-rspack-plugin
export default {"main":"EditHealthCheckupInstitution__main--Zyjh9"};